import { render, staticRenderFns } from "./guwen.vue?vue&type=template&id=04de789d"
import script from "./guwen.vue?vue&type=script&lang=js"
export * from "./guwen.vue?vue&type=script&lang=js"
import style0 from "./guwen.vue?vue&type=style&index=0&id=04de789d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports